<template>
    <button @click="showModal">
        <slot></slot>
    </button>
</template>
<script>
export default {
    methods: {
        showModal(){
            this.$root.$emit("openModal", true);
        }
    },
}
</script>
